import { render, staticRenderFns } from "./import-review.vue?vue&type=template&id=28065caa&scoped=true"
import script from "./import-review.vue?vue&type=script&lang=js"
export * from "./import-review.vue?vue&type=script&lang=js"
import style0 from "./import-review.vue?vue&type=style&index=0&id=28065caa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28065caa",
  null
  
)

export default component.exports